import { getCookie } from './getCookie';

export const isWebviewByCookie = Boolean(getCookie('application_version'));

/**
 * Android 웹뷰인지 여부를 반환 (쏘카 14.8.0 버전 미만)
 */
const checkIsAndroidWebviewV1 = () => {
  const { userAgent } = window.navigator;
  return /NaOS\/appVersion/.test(userAgent) && /PlayStore/.test(userAgent);
};

/**
 * Android 웹뷰인지 여부를 반환 (쏘카 14.8.0 버전 이상)
 */
const checkIsAndroidWebviewV2 = () => {
  const { userAgent } = window.navigator;
  return /Socar/.test(userAgent) && /PlayStore/.test(userAgent);
};

/**
 * Android 웹뷰인지 여부
 */
export const isAndroidWebview =
  checkIsAndroidWebviewV1() || checkIsAndroidWebviewV2();

/**
 * iOS 웹뷰인지 여부를 반환
 */
const checkIsIOSWebview = () => /SOCAR/.test(window.navigator.userAgent);

/**
 * iOS 웹뷰인지 여부
 */
export const isIOSWebview = checkIsIOSWebview();

/**
 * Webview 환경인지 여부를 반환
 */
export const isWebview = () =>
  isWebviewByCookie || isAndroidWebview || isIOSWebview;
